import './CTA.css';
import { useScrollReveal } from '../hooks/useScrollReveal';

function CTA() {
  const [ref, visible] = useScrollReveal(0.15);
  return (
    <section ref={ref} className={`cta-section ${visible ? 'visible' : ''}`}>
      <div className="cta-content">
        <h2>Ready to transform your clinic?</h2>
        <p>
          Join clinics that have moved away from manual processes and fragmented data.
          Get clarity, structure, and peace of mind.
        </p>
        <a href="https://app.lemadoo.com/sign-up" className="cta-button" target="_blank" rel="noopener noreferrer">Get Started for Free</a>
      </div>
    </section>
  );
}

export default CTA;
